import React, { useState } from "react";
import "./DoctorsContact.css";
import { medicos } from "../data/medicos";
import { marcas } from "../data/marcas";

export default function DoctorsContact() {
  const [busqueda, setBusqueda] = useState("");
  const [tipoFiltro, setTipoFiltro] = useState("Todos");
  const [marcaFiltro, setMarcaFiltro] = useState("Todas");

  // Filtrar médicos según búsqueda, tipo y marca
  const medicosFiltrados = medicos.filter((m) => {
    const matchBusqueda =
      m.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      m.producto.toLowerCase().includes(busqueda.toLowerCase());

    const matchTipo =
      tipoFiltro === "Todos" ||
      m.tipo.toLowerCase() === tipoFiltro.toLowerCase();

    const matchMarca =
      marcaFiltro === "Todas" || m.producto === marcaFiltro;

    return matchBusqueda && matchTipo && matchMarca;
  });

  // Agrupar médicos por marca (solo las que tienen médicos)
  const grupos = marcas.reduce((acc, marca) => {
    const medicosPorMarca = medicosFiltrados.filter(
      (m) => m.producto === marca.nombre
    );
    if (medicosPorMarca.length > 0) {
      acc[marca.nombre] = medicosPorMarca;
    }
    return acc;
  }, {});

  const marcasConMedicos = Object.keys(grupos);

  return (
    <main className="medicos-container" aria-label="Directorio de médicos estéticos por marca">
      <h2 className="medicos-titulo">Encuentra Médicos Estéticos por Marca</h2>

      {/* Filtros */}
      <div className="filtros-container" role="region" aria-label="Filtros de búsqueda">
        <label htmlFor="buscar" className="visually-hidden">
          Buscar médico:
        </label>
        <input
          id="buscar"
          type="text"
          placeholder="Buscar médico o marca..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="input-busqueda"
        />

        <label htmlFor="tipoFiltro" className="visually-hidden">
          Filtrar por categoría:
        </label>
        <select
          id="tipoFiltro"
          value={tipoFiltro}
          onChange={(e) => setTipoFiltro(e.target.value)}
          className="select-filtro"
        >
          <option value="Todos">Todos los tipos</option>
          <option value="Tecnología">Tecnologías</option>
          <option value="Insumo">Insumos</option>
        </select>

        <label htmlFor="marcaFiltro" className="visually-hidden">
          Filtrar por marca:
        </label>
        <select
          id="marcaFiltro"
          value={marcaFiltro}
          onChange={(e) => setMarcaFiltro(e.target.value)}
          className="select-filtro"
        >
          <option value="Todas">Todas las marcas</option>
          {marcas.map((m, i) => (
            <option key={i} value={m.nombre}>
              {m.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Mostrar médicos filtrados */}
      {marcasConMedicos.length > 0 ? (
        marcasConMedicos.map((nombreMarca, i) => (
          <section
            key={i}
            className="marca-section"
            aria-labelledby={`marca-${i}`}
          >
            <h3 id={`marca-${i}`} className="marca-titulo">
              {nombreMarca}
            </h3>
            <div className="medicos-grid">
              {grupos[nombreMarca].map((m, index) => (
                <article
                  key={m.id}
                  className="medico-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  aria-label={`Información del doctor ${m.nombre}`}
                >
                  <div className="medico-imagen-container">
                    <img
                      src={m.foto}
                      alt={`Fotografía de ${m.nombre}`}
                      className="medico-imagen"
                      loading="lazy"
                    />
                    <div className="medico-info-overlay">
                      <h3>{m.nombre}</h3>
                      <p>{m.lugar}</p>
                    </div>
                  </div>

                  <div className="medico-detalles">
                    <p>
                      <strong>🏥 Clínica:</strong> {m.direccion}
                    </p>
                    <p>
                      <strong>📞 Teléfono:</strong> {m.telefono}
                    </p>

                    <div className="medico-botones">
                      <a
                        href={m.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-whatsapp"
                        aria-label={`Contactar a ${m.nombre} por WhatsApp`}
                      >
                        WhatsApp
                      </a>
                      <a
                        href={m.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-instagram"
                        aria-label={`Ver perfil de Instagram de ${m.nombre}`}
                      >
                        Instagram
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))
      ) : (
        <p className="sin-medicos">
          No se encontraron médicos con los filtros seleccionados.
        </p>
      )}
    </main>
  );
}
